// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import App from './App';
import universe from './store';

Vue.config.productionTip = false;

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  store: universe,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js